import { render, staticRenderFns } from "./Qna.vue?vue&type=template&id=7f34c000&lang=pug&"
import script from "./Qna.vue?vue&type=script&lang=ts&"
export * from "./Qna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports